import Logging from '@fjell/logging';

const LibLogger = Logging.getLogger('@fjell/http-api');

export default LibLogger;
